<template>
  <div>
    <el-upload
      :http-request="upload"
      ref="upload"
      :drag="drag"
      :show-file-list="false"
      action="wwm"
      multiple
      :limit="limit"
      :on-exceed="
        (files, fileList) => {
          this.$message.warning(
            `当前限制选择 ${limit} 个文件，本次选择了 ${files.length} 个文件`
          );
        }
      "
      ><slot></slot> </el-upload
    ><el-dialog
      :visible.sync="dialogVisible"
      title="上传进度"
      :before-close="close"
    >
      <div v-for="(p, i) in percentage" :key="'percentage' + i" class="jdt">
        <span :title="p.name" class="name">{{ p.name }}</span>
        <em class="total">
          <em
            class="finish"
            :style="'width:' + (p.finish * 100) / p.total + '%'"
          ></em>
        </em>
        <span class="percentage">{{
          p.status == "上传中"
            ? p.finish != p.total
              ? Math.floor((p.finish * 10000) / p.total) / 100 + "%"
              : "合并文件中"
            : p.status
        }}</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import SparkMD5 from "spark-md5";
export default {
  data() {
    return {
      dialogVisible: false,
      files: [],
      percentage: [],
      headers: { "Content-Type": "multipart/form-data" },
      filetype: [
        { name: "doc", value: 1 },
        { name: "docx", value: 1 },
        { name: "ppt", value: 2 },
        { name: "pptx", value: 2 },
        { name: "pdf", value: 3 },
        { name: "png", value: 4 },
        { name: "jpg", value: 4 },
        { name: "jpeg", value: 4 },
        { name: "gif", value: 4 },
        { name: "bmp", value: 4 },
        { name: "mp4", value: 5 },
      ],
    };
  },
  props: {
    value: { type: Array },
    limit: { type: Number, default: 0 },
    url: { type: String },
    size: { type: Number, default: 1024 * 1024 * 30 },
    auth: { type: Object },
    parallel: { type: Number, default: 3 },
    drag: { type: Boolean, default: false },
  },
  methods: {
    close() {
      if (
        this.percentage.length ==
        this.percentage.filter((el) => el.status == "上传成功").length
      ) {
        this.dialogVisible = false;
        this.percentage = [];
      } else {
        this.$confirm("尚未上传完成，是否取消上传?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.dialogVisible = false;
            this.percentage = [];
            this.$refs.upload.clearFiles();
          })
          .catch(() => {});
      }
    },
    async upload(option, a, b) {
      console.log(a);
      Object.assign(this.headers, this.auth);
      this.dialogVisible = true;
      const spark = new SparkMD5.ArrayBuffer(); // md5的ArrayBuffer加密类
      const fileReader = new FileReader(); // 文件读取类
      const action = option.action; // 文件上传上传路径
      const chunkSize = this.size; // 单个分片大小
      let md5 = ""; // 文件的唯一标识
      const optionFile = option.file; // 需要分片的文件
      let fileChunkedList = []; // 文件分片完成之后的数组
      // const percentage = [] // 文件上传进度的数组，单项就是一个分片的进度
      let num = 0;

      // 文件开始分片，push到fileChunkedList数组中， 并用第一个分片去计算文件的md5
      for (let i = 0; i < optionFile.size; i = i + chunkSize) {
        const tmp = optionFile.slice(
          i,
          Math.min(i + chunkSize, optionFile.size)
        );
        if (i === 0) {
          fileReader.name = optionFile.name;
          fileReader.readAsArrayBuffer(tmp);
        }
        num++;
        fileChunkedList.push(tmp);
      }

      // 在文件读取完毕之后，开始计算文件md5，作为文件唯一标识
      fileReader.onload = async (e) => {
        spark.append(e.target.result);
        md5 = spark.end() + new Date().getTime();
        // console.log("文件md5为--------", md5);
        let r = e.currentTarget.name.match(/([^\\/]+)\.([^\\/]+)/i);
        let filetype = this.filetype.filter((el) => el.name == r[2]);
        this.percentage.push({
          md5: md5,
          total: fileChunkedList.length,
          finish: 0,
          status: "上传中",
          name: e.currentTarget.name,
          url: "",
          type: "." + r[2],
          size: optionFile.size,
          fileName: r[1],
          fileUrl: "",
          fileSize: optionFile.size,
          filePage: "",
          resourceTypeId: "",
          fileType: filetype.length > 0 ? filetype[0].value : 0,
          isShareSystem: true,
          isPrint: "",
          printType: "",
          printNumber: "",
        });
        // 将fileChunkedList转成FormData对象，并加入上传时需要的数据
        fileChunkedList = fileChunkedList.map((item, index) => {
          const formData = new FormData();
          // if (option.data) {
          // 额外加入外面传入的data数据
          // Object.keys(option.data).forEach(key => {
          //     formData.append(key, option.data[key])
          // })
          // 这些字段看后端需要哪些，就传哪些，也可以自己追加额外参数
          formData.append("file", item); // 文件
          formData.append("Chunk", index + 1); // 当前文件块
          formData.append("Id", md5); // 文件标识
          formData.append("Chunks", fileChunkedList.length); // 总块数
          // formData.append('chunkSize', chunkSize)// 单个分块大小
          // formData.append('currentChunkSize', item.size)// 当前分块大小
          // formData.append('totalSize', optionFile.size)// 文件总大小
          // formData.append('filename', option.file.name)// 文件名
          // }
          return { formData: formData, index: index, md5: md5 };
        });

        // 创建队列上传任务，limit是上传并发数
        let sendRequest = (chunks, limit = 3) => {
          return new Promise((resolve, reject) => {
            const len = chunks.length;
            let counter = 0;
            let isStop = false;
            const start = async () => {
              if (isStop) {
                return false;
              }
              const item = chunks.shift();

              if (item) {
                let res = await axios.post(
                  this.url + "/UploadChunkFile",
                  item.formData,
                  {
                    headers: this.headers,
                  }
                );

                if (res.data.suc) {
                  this.percentage.filter((el) => el.md5 == md5)[0].finish++;
                  if (counter === len - 1) {
                    // 最后一个上传完成
                    resolve();
                  } else {
                    counter++;
                    start();
                  }
                } else {
                  this.percentage.filter((el) => el.md5 == md5)[0].status =
                    "上传出错";
                  isStop = true;
                  this.$message.error(res.data.msg);
                  reject(res.data.msg);
                }
              }
            };
            while (limit > 0) {
              setTimeout(() => {
                start();
              }, Math.random() * 1000);
              limit -= 1;
            }
          });
        };

        try {
          // 调用上传队列方法 等待所有文件上传完成
          await sendRequest(fileChunkedList, this.parallel);
          // 这里的参数根据自己实际情况写
          const data = {
            Id: md5,
            FileName: option.file.name,
            Chunks: num,
          };
          // 给后端发送文件合并请求
          const fileInfo = await axios.post(this.url + "/MergeFile", data, {
            headers: this.headers,
          });
          if (fileInfo.data.suc) {
            this.percentage.filter((el) => el.md5 == md5)[0].status =
              "上传成功";
            this.percentage.filter((el) => el.md5 == md5)[0].fileUrl =
              fileInfo.data.data.Path;

            if (
              this.percentage.length ==
              this.percentage.filter((el) => el.status == "上传成功").length
            ) {
              this.$emit("input", this.percentage);
              this.$refs.upload.clearFiles();
              this.dialogVisible = false;
              this.percentage = [];
            }
          }
        } catch (error) {
          option.onError(error);
        }
      };
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/common/upload1.vue